import React, { useRef } from "react";
import { Images, Services } from "../../../Controller";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { IoArrowBack, IoArrowForwardOutline } from "react-icons/io5";
import { Carousel } from "antd";
import { getAEPSiciciUpdateStatus } from "../../../ApiServices/Apifun";
// function DashboardCommon({
//   banners,
//   cardData,
//   showModalForUpdate,
//   setShowModalForUpdate,
//   setPendingRoute,
//   setShowModalForEkycUpdate,
//   showModalForEkycUpdate,
//   setExpired_date,
//   expired_date,
// }) {
function DashboardCommon() {
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const serviceRef = useRef();
  const scrollLeft = () => {
    if (serviceRef.current) {
      serviceRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const checkStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    } else {
      return to;
    }
  };
  const scrollRight = () => {
    if (serviceRef.current) {
      serviceRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };
  const checkCredoStatus = () => {
    if (!profiledetail.credo_aeps_onboard) {
      return "/banking/aeps2-onboard";
    } else if (!profiledetail.credo_aeps_status) {
      return "/banking/waiting";
    } else if (
      profiledetail.credo_aeps_onboard &&
      profiledetail.credo_aeps_status
    ) {
      return "/banking/aeps2-2fa";
    }
  };
  const navigate = useNavigate();
  const checkDigiStatus = () => {
    if (
      profiledetail.digio_kyc === "0" ||
      profiledetail.digio_kyc === "2" ||
      profiledetail.digio_kyc === "3"
    ) {
      return true;
    }
  };
  const checkWithdrawalStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    }
    //  else if (withdrawalTime === 0) {
    //   return "/banking/aeps";
    // }
    else {
      return to;
    }
  };
  const checkAEPSiciciUpdateStatus = async (e, route, state) => {
    try {
      const res = await getAEPSiciciUpdateStatus();

      if (res.status && res.data.pinwallet_onboard_status == 0) {
        e.preventDefault();
        setExpired_date(res.data.expired_date);
        setPendingRoute({
          route,
          state,
        });

        setShowModalForUpdate(true);
        return;
      } else if (res.status && res.data.pinwallet_ekyc_status == 0) {
        setExpired_date(res.data.expired_date);
        e.preventDefault(); // navigation stop

        setPendingRoute({
          route,
          state,
        });

        setShowModalForEkycUpdate(true);
        return;
      }
    } catch (err) {
      console.log(err);
      e.preventDefault();
      return;
    }
  };
  return (
    <div className="m-4">
      {" "}
      {/* md:grid-cols-3 lg:grid-cols-[30%_16.4%_16.4%_16.4%_16.4%_] */}
      <div className="grid grid-cols-1 sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-[30%_22.4%_22.4%_22.4%_] place-items-start gap-3">
        <div
          className="shadow-[0px_2px_2px_#ccdcff] cursor-pointer p-6 border-gray-300  border bg-white h-36 w-full rounded-xl"
          onClick={() => navigate("/personal-info")}
        >
          <p className="text-[#00426c] text-xl font-bold capitalize">
            Hi , {profiledetail.first_name} {profiledetail.last_name}
          </p>
          <p className="text-black text-lg">Ready to earn with Easy2Pay</p>
        </div>
        <div
          className="shadow-[0px_2px_2px_#ccdcff] p-2 border-[#00426c] border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
          onClick={() =>
            navigate(
              checkDigiStatus()
                ? "/kycStatus"
                : memberServices.includes("5")
                  ? "/payout/verification"
                  : "/not-available",
            )
          }
        >
          <img
            src={Images.cashDeposit}
            className="flex justify-start m-auto items-start w-16 text-[#00426c]"
            alt="Payout"
          />
          <p className="text-[#00426c] text-base leading-5 font-bold mt-4">
            Payout
          </p>
        </div>
        <div
          className="shadow-[0px_2px_2px_#ccdcff] p-2 border-[#00426c] border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
          onClick={() =>
            navigate(
              checkDigiStatus()
                ? "/kycStatus"
                : memberServices.includes("202")
                  ? "/bbps/v1"
                  : "/not-available",
            )
          }
        >
          <img
            src={Images.DMT}
            className="flex justify-start m-auto items-start w-16 text-[#00426c]"
            alt="BBPS"
          />
          <p className="text-[#00426c] text-base leading-5 font-bold mt-4">
            BBPS
          </p>
        </div>

        <NavLink
          className="block w-full no-underline"
          to={
            checkDigiStatus()
              ? "/kycStatus"
              : memberServices.includes("4")
                ? "/dmt3/remitters"
                : "/not-available"
          }
        >
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-[#00426c] border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer">
            <img
              src={Images.DMT}
              className="flex justify-start m-auto items-start w-16"
              alt="Money Transfer"
            />
            <p className="text-[#00426c] text-base leading-5 font-bold mt-4 text-center">
              Money Transfer
            </p>
          </div>
        </NavLink>
      </div>
      <div>
        <p className="text-[#00426c] flex justify-start text-lg  font-bold mt-2">
          Our Services
        </p>
        <div className="relative">
          <div
            ref={serviceRef}
            className="w-full overflow-x-auto scrollbar-hide"
          >
            <div className="flex gap-5 w-full p-4">
              <NavLink
                className="block w-full no-underline"
                to={
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("8")
                      ? checkWithdrawalStatus("/banking/aeps-cash-withdrawl")
                      : "/not-available"
                }
                state={{ from: "/banking/aeps-cash-withdrawl", type: "aeps" }}
                // onClick={(e) =>
                //   checkAEPSiciciUpdateStatus(
                //     e,
                //     checkDigiStatus()
                //       ? "/kycStatus"
                //       : memberServices.includes("8")
                //         ? checkWithdrawalStatus("/banking/aeps-cash-withdrawl")
                //         : "/not-available",
                //     {
                //       from: "/banking/aeps-cash-withdrawl",
                //       type: "aeps",
                //     },
                //   )
                // }
              >
                <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer">
                  <img
                    src={Services.insurance}
                    className="flex justify-center m-auto  w-12 text-[#00426c] h-8 sm:h-10 md:12 "
                    alt="DMT"
                  />
                  <p className="text-black flex justify-center text-center text-xs leading-3  font-bold mt-4">
                    Cash Withdrawal
                  </p>
                </div>
              </NavLink>

              <NavLink
                className="block w-full no-underline"
                to={
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("8")
                      ? checkWithdrawalStatus("/banking/aeps-cash-deposit")
                      : "/not-available"
                }
                state={{
                  from: "/banking/aeps-cash-deposit",
                  type: "cash_deposit",
                }}
                // onClick={(e) =>
                //   checkAEPSiciciUpdateStatus(
                //     e,
                //     checkDigiStatus()
                //       ? "/kycStatus"
                //       : memberServices.includes("8")
                //         ? checkWithdrawalStatus("/banking/aeps-cash-deposit")
                //         : "/not-available",
                //     {
                //       from: "/banking/aeps-cash-deposit",
                //       type: "cash_deposit",
                //     },
                //   )
                // }
              >
                <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer">
                  <img
                    src={Services.insurance}
                    className="flex justify-center m-auto  w-12 text-[#00426c] h-8 sm:h-10 md:12 "
                    alt="Cash Deposit"
                  />
                  <p className="text-black flex justify-center text-center text-xs leading-3  font-bold mt-4">
                    Cash Deposit
                  </p>
                </div>
              </NavLink>

              <NavLink
                className="block w-full no-underline"
                s
                to={
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("8")
                      ? checkStatus("/banking/aeps-miniStatement")
                      : "/not-available"
                }
                state={{ from: "/banking/aeps-miniStatement", type: "aeps" }}
                // onClick={(e) =>
                //   checkAEPSiciciUpdateStatus(
                //     e,
                //     checkDigiStatus()
                //       ? "/kycStatus"
                //       : memberServices.includes("8")
                //         ? checkWithdrawalStatus("/banking/aeps-miniStatement")
                //         : "/not-available",
                //     {
                //       from: "/banking/aeps-miniStatement",
                //       type: "aeps",
                //     },
                //   )
                // }
              >
                <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer">
                  <img
                    src={Services.credit_report}
                    className="flex justify-center m-auto  w-12 text-[#00426c] h-8 sm:h-10 md:12 "
                    alt="Mini Statement"
                  />
                  <p className="text-black flex justify-center text-center text-xs leading-3  font-bold mt-4">
                    Mini Statement
                  </p>
                </div>
              </NavLink>
              <NavLink
                className="block w-full no-underline"
                to={
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("8")
                      ? checkStatus("/banking/aeps-balanceEnquiry")
                      : "/not-available"
                }
                state={{ from: "/banking/aeps-balanceEnquiry", type: "aeps" }}
                // onClick={(e) =>
                //   checkAEPSiciciUpdateStatus(
                //     e,
                //     checkDigiStatus()
                //       ? "/kycStatus"
                //       : memberServices.includes("8")
                //         ? checkWithdrawalStatus("/banking/aeps-balanceEnquiry")
                //         : "/not-available",
                //     {
                //       from: "/banking/aeps-balanceEnquiry",
                //       type: "balanceEnquiry",
                //     },
                //   )
                // }
              >
                <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer">
                  <img
                    src={Services.elecbill}
                    className="flex justify-center m-auto  w-12 text-[#00426c] h-8 sm:h-10 md:12 "
                    alt="DMT"
                  />
                  <p className="text-black flex justify-center text-center text-xs leading-3  font-bold mt-4">
                    Balance Enquiry
                  </p>
                </div>
              </NavLink>
              <NavLink
                className="block w-full no-underline"
                to={
                  checkDigiStatus()
                    ? "/kycStatus"
                    : memberServices.includes("8")
                      ? checkWithdrawalStatus("/banking/aeps-aadharpay")
                      : "/not-available"
                }
                state={{ from: "/banking/aeps-aadharpay", type: "aadhar_pay" }}
                // onClick={(e) =>
                //   checkAEPSiciciUpdateStatus(
                //     e,
                //     checkDigiStatus()
                //       ? "/kycStatus"
                //       : memberServices.includes("8")
                //         ? checkWithdrawalStatus("/banking/aeps-aadharpay")
                //         : "/not-available",
                //     {
                //       from: "/banking/aeps-aadharpay",
                //       type: "aadhar_pay",
                //     },
                //   )
                // }
              >
                {" "}
                <div className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer">
                  <img
                    src={Services.fastag}
                    className="flex justify-center m-auto  w-12 text-[#00426c] h-8 sm:h-10 md:12 "
                    alt="DMT"
                  />
                  <p className="text-black flex justify-center text-center text-xs leading-3  font-bold mt-4">
                    Aadhaar Pay
                  </p>
                </div>
              </NavLink>

              <div
                className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
                onClick={() =>
                  navigate(
                    checkDigiStatus()
                      ? "/kycStatus"
                      : memberServices.includes("201")
                        ? "/recharge/v1"
                        : "/not-available",
                  )
                }
              >
                <img
                  src={Services.mobileRecharge}
                  className="flex justify-center m-auto  w-12 text-[#00426c] h-8 sm:h-10 md:12 "
                  alt="DMT"
                />
                <p className="text-black flex justify-center text-center text-xs leading-3  font-bold mt-4">
                  Recharges
                </p>
              </div>
              <div
                className="shadow-[0px_2px_2px_#ccdcff] border p-4 border-gray-300  bg-white h-28 w-full rounded-xl cursor-pointer"
                onClick={() => navigate("/panServices")}
              >
                <img
                  src={Services.insurance}
                  className="flex justify-center m-auto  w-12 text-[#00426c] h-8 sm:h-10 md:12 "
                  alt="DMT"
                />
                <p className="text-black flex justify-center text-center text-xs leading-3  font-bold mt-4">
                  PAN Services
                </p>
              </div>
            </div>
          </div>
          <p
            onClick={scrollLeft}
            className="absolute z-10 left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-[#00426c] border-2 border-[#00426c] flex justify-center items-center cursor-pointer"
          >
            <IoArrowBack size={20} className="text-white" />
          </p>
          <p
            onClick={scrollRight}
            className="absolute z-10 right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-[#00426c] border-2 border-[#00426c] flex justify-center items-center cursor-pointer"
          >
            <IoArrowForwardOutline size={20} className="text-white" />
          </p>
        </div>
      </div>
    </div>
  );
}
export default DashboardCommon;
